import React, {useState} from "react";
import {Box, Button, Columns, Form} from "react-bulma-components";
import Collapsible from "react-collapsible";
import TaxTypePicker from "./TaxTypePicker";


export default function NewNominalCode({onSave}){
    const [code, setCode] = useState({});

    const onChange = e => {
        let newCode = {...code, [e.target.name]: e.target.value}
        setCode(newCode);
    };

    const onCheck = e => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: !code[e.target.name]
            }
        };
        onChange(toUpdate);
    }

    const handleSave = (code) => {
        if(!(!!code.tax_type)){
            const toUpdate = {
                target: {
                    name: "tax_type",
                    value: "OUTPUT2"
                }
            }
            onChange(toUpdate);
        }
        onSave(code)
    }

    return (
        <Box>
            <Collapsible
                trigger={"Add Nominal Code"}
                triggerOpenedClassName={"title"}
                className={"title"}
            >
            <Columns>
                <Columns.Column>
                    <Form.Label>Name</Form.Label>
                    <Form.Input
                        type={"text"}
                        name={"name"}
                        value={code.name}
                        onChange={onChange}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Code</Form.Label>
                    <Form.Input
                        type={"text"}
                        name={"code"}
                        value={code.code}
                        onChange={onChange}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Type</Form.Label>
                    <Form.Input
                        type={"text"}
                        name={"type"}
                        value={code.type}
                        onChange={onChange}
                    />
                </Columns.Column>
                <Columns.Column>
                    <TaxTypePicker
                        label={"Tax Type"}
                        onChange={onChange}
                        value={code.tax_type}
                        name={"tax_type"}
                        disabled={false}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Bank Account Number</Form.Label>
                    <Form.Input
                        type={"text"}
                        name={"bank_account_number"}
                        value={code.bank_account_number}
                        onChange={onChange}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Description</Form.Label>
                    <Form.Textarea
                        name={"description"}
                        value={code.description}
                        onChange={onChange}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Enable Payments To Account</Form.Label>
                    <Form.Checkbox
                        name={"enable_payments_to_account"}
                        checked={code.enable_payments_to_account}
                        onChange={onCheck}
                    />
                </Columns.Column>
                <Columns.Column>
                    <Form.Label>Show In Expense Claims</Form.Label>
                    <Form.Checkbox
                        name={"show_in_expense_claims"}
                        checked={code.show_in_expense_claims}
                        onChange={onCheck}
                    />
                </Columns.Column>
            </Columns>
            <Columns>
                <Columns.Column>
                    <Button
                        fullwidth
                        color={"success"}
                        onClick={() => handleSave(code)}
                    >
                       Create
                    </Button>
                </Columns.Column>
            </Columns>
        </Collapsible>
      </Box>
    )


}